import { Slide, TableCell } from '@features/powerpoint';
import { contentSlideHeader, generateTable } from '../../../../utils';
import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { sortBy } from '@utils/arrays';
import { TABLE_HEADER_OPTIONS } from '../sales-attribution/rsa-dimensions-table-slide';
import { CampaignAnalyticsSlideProps } from './build-campaign-analytics-slides';

const ROWS_PER_TABLE = 20;
const SMALL_COLUMN_WIDTH = 1;
const MEDIUM_COLUMN_WIDTH = 2;
const LARGE_COLUMN_WIDTH = 5;
const VISITS_DISCLAIMER =
  'Visit Index (Average = 100) : Baseline: Observable InMarket universe';
const visitColumnLabels: TableCell[] = [
  {
    text: 'Rank',
    options: TABLE_HEADER_OPTIONS,
  },
  {
    text: 'Name',
    options: TABLE_HEADER_OPTIONS,
  },
  {
    text: 'Address',
    options: { ...TABLE_HEADER_OPTIONS, align: 'left' },
  },
  {
    text: 'City',
    options: { ...TABLE_HEADER_OPTIONS },
  },
  {
    text: 'State',
    options: { ...TABLE_HEADER_OPTIONS },
  },
  {
    text: 'Zip',
    options: { ...TABLE_HEADER_OPTIONS },
  },
  {
    text: 'Index',
    options: { ...TABLE_HEADER_OPTIONS },
  },
];

const brandLocationsRows = (
  brandLocations: CampaignAnalyticsReport['brandLocationVisits']
): TableCell[][] => {
  const topBrandLocationsRows = brandLocations.data
    .toSorted(sortBy('index', 'desc'))
    .slice(0, ROWS_PER_TABLE)
    .map((location, index): TableCell[] => {
      const rank = (index + 1).toString();

      return [
        { text: rank, options: { align: 'left' } },
        {
          text: location.name.toString(),
          options: { align: 'left' },
        },
        { text: location.address.toString(), options: { align: 'left' } },
        { text: location.city.toString(), options: { align: 'left' } },
        { text: location.state.toString(), options: { align: 'left' } },
        { text: location.zip.toString(), options: { align: 'left' } },
        { text: location.index.toString(), options: { align: 'left' } },
      ];
    });

  return topBrandLocationsRows;
};

export const brandLocationsTableSlide = (
  props: CampaignAnalyticsSlideProps
): Slide => {
  const tables = [];

  tables.push(
    generateTable(
      visitColumnLabels,
      brandLocationsRows(props.campaignAnalyticsReport.brandLocationVisits),
      {
        rowH: 0.1,
        colW: [
          SMALL_COLUMN_WIDTH,
          SMALL_COLUMN_WIDTH,
          LARGE_COLUMN_WIDTH,
          MEDIUM_COLUMN_WIDTH,
          SMALL_COLUMN_WIDTH,
          SMALL_COLUMN_WIDTH,
          SMALL_COLUMN_WIDTH,
        ],
      }
    )
  );

  return {
    slideMaster: props.slideMaster,
    tables,
    texts: [
      contentSlideHeader('Top 20 Brand Locations Visited', {
        x: 0.75,
        y: 0.6,
      }),
      { text: VISITS_DISCLAIMER, options: { x: 0.67, y: 6.81, fontSize: 8 } },
    ],
  };
};
